import { type ReactElement } from 'react';
import styles from './style.module.scss';

interface PropulsionCountCardProperties {
  readonly vehicleType: 'Bus' | 'Truck';
  readonly bevCount: number;
  readonly phevCount: number;
}

const PropulsionCountCard = ({ vehicleType, bevCount, phevCount }: PropulsionCountCardProperties): ReactElement => (
  <article className={styles.container}>
    <div className={styles.segment}>
      <h2>{vehicleType} (BEV)</h2>
      <div className={styles.count}>{bevCount}</div>
    </div>
    <div className={styles.segment}>
      <h2>{vehicleType} (PHEV)</h2>
      <div className={styles.count}>{phevCount}</div>
    </div>
  </article>
);

export default PropulsionCountCard;
